import { put, takeLatest, fork, call } from "redux-saga/effects";
import { ActionType, IPatientCSVResponse } from "models/patients/downloadCSV";
import { PatientsPayload } from "models/patients/patientList";
import { httpStatus } from "configs/httpStatus";
import { downloadPatientsCSV } from "services/patients";

import {
  handleSuccessAction,
  handleErrorAction,
} from "./downloadPatientCSVActions";

function* patientCSVSaga({ payload }: { payload: PatientsPayload }) {
  try {
    const response: IPatientCSVResponse = yield call(
      downloadPatientsCSV,
      payload
    );
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccessAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onGetPatientCSVWatcher() {
  yield takeLatest(ActionType.DOWNLOAD_PATIENT_CSV as any, patientCSVSaga);
}

export default [fork(onGetPatientCSVWatcher)];
